export default __webpack_public_path__ + "static/media/play-button.4dc0c33e.svg";